import CloseOutlined from '@ant-design/icons/CloseOutlined'
import { Button } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { memo, useEffect, useState } from 'react'
import WorkOutgoingDocCreateForm from '../../../Documents/InternalDocumentOutgoingDocCreatePage/workOutgoingDocCreateForm'
import { ModalRelease } from './PopupReleaseElectronicDocumentStyled'

const PopupReleaseElectronicDocument = props => {
  const {
    fileActive,
    isVisiblePopupRelease,
    electronicDocumentStore,
    handleClosePopupElectronicDocument,
  } = props

  const { selectedElectronicDocument } = electronicDocumentStore
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [fileRelease, setFileRelease] = useState([])

  useEffect(() => {
    if (!fileActive || !Array.isArray(fileActive) || fileActive.length === 0) {
      setFileRelease([])
      return
    }

    const formattedFiles = fileActive.map(file => ({
      file_id: file.file_id,
      file_name: file.file_name,
    }))

    setFileRelease(formattedFiles)
  }, [fileActive])

  useEffect(() => {
    setUploadedFiles(selectedElectronicDocument?.attachments || [])
  }, [selectedElectronicDocument?.attachments])

  return (
    <ModalRelease
      visible={isVisiblePopupRelease}
      footer={null}
      closable={false}
      title={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <span>Phát hành tài liệu</span>
          <Button
            type={'text'}
            icon={<CloseOutlined />}
            onClick={handleClosePopupElectronicDocument}
          />
        </div>
      }
      width={900}
      style={{ top: 40 }}>
      <WorkOutgoingDocCreateForm
        fileReleaseAttachList={uploadedFiles}
        fileRelease={fileRelease}
        isReleaseDocument
        handleCancel={handleClosePopupElectronicDocument}
      />
    </ModalRelease>
  )
}

PopupReleaseElectronicDocument.propTypes = {}

export default memo(
  inject('electronicDocumentStore')(observer(PopupReleaseElectronicDocument))
)
